import React from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import Avatar from '../components/Avatar';
import { Link, useNavigate } from "react-router-dom";

function Worders(props) {
    return (
        <div className="w-home row w-fullscreen">
            <div className='col-lg-3 bg-blue w-half-left'>
                <Avatar
                    type="w-avatar-info"
                    nom="David"
                    mail="david.st@word.in"
                    worder="WOrder : 30"
                    src="/img/players/player_d.png"
                    classes="w-avatar-info"
                />
                <Link to="/home">
                    <Button text="Accueil" classes="w-btn-white" />
                </Link>
                <Link to="/partielettre">
                    <Button text="Nouvelle partie" classes="w-btn-white" />
                </Link>
                <Link to="/scores">
                    <Button text="Voir les scores" classes="w-btn-white" />
                </Link>
                <Link to="/worders">
                    <Button text="Les WOrders (50)" classes="w-btn w-btn-blue" />
                </Link>
                <Link to="/">
                    <Button text="Quitter" classes="w-text w-btn-gray" />
                </Link>
                <Link to="/aide">
                    <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
                </Link>
            </div>
            <div className='col-lg-9 w-half-right-full'>
                <br/>
                <center className='row'>
                    <Text text="En ligne : 250" classes="w-text-green-bold" />
                </center>
                
                <br/>
                <div className='row'>

                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                    <div className="col-lg-3">
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm  w-avatar-sm-mt bg-blue-semi-lte"
                        />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Worders;